module.exports = __webpack_public_path__ + "lp/img/vocabulary_instruction.440a63b8.png";